module.exports = __webpack_public_path__ + "img/12.37746ab7.jpg";